import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App, metadataForPath } from "./App";
import { I18nProvider, initializeLocale } from "./i18n";
import { setPageMetadata } from "./lib/metadata";
import "./styles.css";
import "./i18n/locale.css";

const root = document.getElementById("root");

if (!root) {
  throw new Error("Root element not found");
}

const initialLocale = initializeLocale();
const initialMetadata = metadataForPath(window.location.pathname, initialLocale);
setPageMetadata(initialMetadata.title, initialMetadata.description);

createRoot(root).render(
  <StrictMode>
    <I18nProvider initialLocale={initialLocale}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </I18nProvider>
  </StrictMode>
);
